module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department_sp06-2aac9e61fa2a31389cdcc387991576c5.jpg";